<template>
    <div>
        <sub-menu-call-center ativo="call-center" v-if="!fluxo" />
        <marcacao 
            :remarcacao="remarcacao" 
            :adicao="adicao"
            :retorno="retorno"
            :autorizacao="autorizacao"
            :id_requisicao_procedimento="id_requisicao_procedimento"
            :id_paciente="id_paciente" 
            :marcar_paciente="marcar_paciente"
            :key="id_paciente ? id_paciente : 0" 
            @fluxo="estado"/>
    </div>
</template>

<script>
import Marcacao from './callcenter/Marcacao.vue'
import SubMenuCallCenter from './callcenter/SubMenuCallCenter.vue';

export default {
    data () { 
        return {
            fluxo: null, 
        }
    },
    props: ['remarcacao', 'adicao', 'autorizacao', 'id_paciente', 'id_requisicao_procedimento', 'marcar_paciente', 'retorno'],
    components: { 
        Marcacao,
        SubMenuCallCenter
    },
    methods: { 
        estado(fluxo) { 
            this.fluxo = fluxo;
        }
    },
    mounted () { 
        this.$store.commit(
            'setBreadcrumb', 
            [
                { name: "Call Center", path: "/call-center"},
                { name: "Marcação", path: "/call-center"}
            ]
        );
    }
}
</script>